import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import ResponsiveAppBar from "./MainAppBar";


const Layout = ({ city, backOfficeFlag }) => {
  
    const location = useLocation();
    console.log("Layout renderowany. Ścieżka:", location.pathname);

    return location.pathname === "/zaplecze/" ? (
        <Outlet />
    ) : (
        <div id='appcontainer'>
            <ResponsiveAppBar city={city} />
            <Outlet />
        </div>
    );
};

export default Layout;